import { render } from "./UiToastHost.vue?vue&type=template&id=4f827a76&scoped=true&ts=true"
import script from "./UiToastHost.vue?vue&type=script&lang=ts"
export * from "./UiToastHost.vue?vue&type=script&lang=ts"

import "./UiToastHost.vue?vue&type=style&index=0&id=4f827a76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f827a76"]])

export default __exports__